import { getAuthorization } from 'controllers/controller';
import { getSkillRelevancyScoreService } from 'services/skillsRecommendation/getSkillRelevancyScore';

export const getSkillRelevancyScore = async (skillSet1, skillSet2) => {
  const authorization = getAuthorization();

  const payload = {
    skills_set_1: skillSet1,
    skills_set_2: skillSet2,
  };

  const { data } = await getSkillRelevancyScoreService(authorization, payload);

  return data.response;
};
